import { ElementRef, forwardRef } from 'react'
import { Flex } from '@radix-ui/themes'
import cn from 'classnames'
import styles from './neon.module.scss'

export type NeonGlow = 'green' | 'purple' | 'cyan' | 'pink' | 'none'
export type NeonPadding = '0' | '1' | '2' | '3'

type FlexProps = React.ComponentPropsWithoutRef<typeof Flex>

type Props = FlexProps & {
  glow?: NeonGlow
  padding?: NeonPadding
}

const GLOW_CLASS_MAP: Record<NeonGlow, string> = {
  green: styles.glowGreen,
  purple: styles.glowPurple,
  cyan: styles.glowCyan,
  pink: styles.glowPink,
  none: styles.glowNone
}

const PADDING_CLASS_MAP: Record<NeonPadding, string> = {
  '0': styles.padding0,
  '1': styles.padding1,
  '2': styles.padding2,
  '3': styles.padding3
}

export const NeonPanel = forwardRef<ElementRef<typeof Flex>, Props>(
  ({ glow = 'none', padding = '2', className, children, ...props }, ref) => {
    return (
      <Flex
        direction={'column'}
        {...props}
        ref={ref}
        className={cn(
          styles.panel,
          GLOW_CLASS_MAP[glow],
          PADDING_CLASS_MAP[padding],
          className
        )}
      >
        {children}
      </Flex>
    )
  }
)
